/**
 * Zod schemas for External Link plugin - URL, button label, new tab flag, and confirmation note.
 */
import { z } from "zod";
/**
 * Configuration schema for the external link step type.
 */
export const configSchema = z.object({
    url: z.string().url("Must be a valid URL"),
    label: z.string().default("Open Link"),
    openInNewTab: z.boolean().default(true),
    instructions: z.string().optional(),
});
/**
 * Data schema for external link step execution.
 */
export const dataSchema = z.object({
    confirmationNote: z.string().optional(),
    clickedAt: z.string().optional(),
});
export const defaultConfig = {
    url: "",
    label: "Open Link",
    openInNewTab: true,
};
//# sourceMappingURL=schema.js.map